import { useEffect, useState } from 'react';

import { INutrient, IProduct } from '@interfaces';
import Pack from '@components/pages/shop/partial/pack';

export default function Packs({ category, filterBy, filterAge, subscribed }: { category: any, filterBy: string, filterAge: any, subscribed: boolean }) {
    const [products, setProducts] = useState(Object.values(category.products));

    useEffect(() => {
        if (filterBy) {
            let data: IProduct[] = [];

            Object.values(category.products)
                .filter((p: IProduct) => category.id !== 'peppa' || p.groups.includes('peppa'))
                .forEach((product: IProduct) => {
                    product.nutrients.forEach((nutrient: INutrient) => {
                        if (nutrient.slug === filterBy) {
                            data[product.id] = product;
                        }
                    });
                });
            setProducts(data);
            return;
        }

        setProducts(Object.values(category.products));
        return;
    }, [filterBy]);

    return (
        <>
            {products.length > 0
                ?
                <div className={`category ${category.id}`} id={`${category.id}`}>
                    <div className="category-title mb-4">
                        <h2>{category.title}
                            {category.pricePerMeal &&
                                <span>${category.pricePerMeal.toFixed(2)} per meal when you subscribe</span>
                            }
                        </h2>
                        <div>
                            <p>{category.description}</p>
                        </div>
                    </div>
                    <div className="products">
                        <div className="row">
                            {
                                products
                                    .filter((product: IProduct) => product.groups.includes('peppa') || category.id !== 'peppa')
                                    .sort((a: any, b: any) => a.availability < b.availability ? -1 : (a.availability > b.availability ? 1 : 0))
                                    .map((product: IProduct) =>
                                        <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
                                            <Pack product={product} disabled={false} filterAge={filterAge} subscribed={subscribed} />
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                </div>
                :
                <></>
            }
        </>
    );
}
